
export default function FinalCTA() {
  return (
    <section className="py-28 px-6 lg:px-12 bg-gradient-to-br from-[#304FFE] to-[#7C4DFF] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-1/4 right-[10%] w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 left-[15%] w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6">
          Your future is one micro skill away
        </h2>
        <p className="text-2xl text-white/90 mb-12">
          Begin today — and let your effort guide your progress.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <button className="px-8 py-4 bg-white text-[#7C4DFF] font-medium rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
            Start Learning
          </button>
          <button className="px-8 py-4 border-2 border-white text-white font-medium rounded-full hover:bg-white hover:text-[#7C4DFF] transition-all whitespace-nowrap cursor-pointer">
            Earn Your First Badge
          </button>
        </div>
      </div>
    </section>
  );
}
